import axios from "axios";
import { filesService } from "@/services/filesService";

export const uploadService = {
  async uploadFile(file, fileName) {
    try {
      // First step: Get the pre-signed POST URL
      const { upload, download } = await filesService.getPresignedUrl(fileName);
      const postURL = upload.url;
      const postFields = upload.fields;

      // Create form data for the upload
      const formData = new FormData();
      const replaceKeys = {
        aWSAccessKeyId: "AWSAccessKeyId",
        xAmzSecurityToken: "x-amz-security-token",
      };
      Object.entries(postFields).forEach(([key, value]) => {
        const newKey = replaceKeys[key] ?? key;
        formData.append(newKey, value);
      });
      formData.append("file", new File([file], fileName));

      // Second step: Upload the file to the presigned POST URL
      await axios.post(postURL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return download;
    } catch (err) {}
  },
};
